import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Delete a Knowledge Base
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestDeleteKnowledgeSet = packet => {
  return {
    type: 'REQUEST_DELETE_KNOWLEDGE',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveDeleteKnowledgeSetSuccess = data => ({
  type: 'RECEIVE_DELETE_KNOWLEDGE_SUCCESS',
  data
})

export const receiveDeleteKnowledgeSetFail = data => ({
  type: 'RECEIVE_DELETE_KNOWLEDGE_FAIL',
  data
})

export const tryToDeleteKnowledgeSet = packet => (dispatch, getState) => {

  dispatch(requestDeleteKnowledgeSet(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/knowledge/' + packet.id, {
      method: 'delete',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(push('/workbench/' + packet.scope));
      dispatch(receiveDeleteKnowledgeSetSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveDeleteKnowledgeSetFail({errors:e, lastSubmit: packet}));
    })
}
